import { QueryClient } from '@tanstack/react-query';

// A factory, not a module-level singleton: on the server, Next.js can reuse
// the same module instance across different users' requests, so a shared
// QueryClient would leak one user's cached data into another's response.
// Each request/render gets its own client via this factory (see
// query-provider.tsx, which calls it inside useState so the client survives
// client-side re-renders but is still fresh per page load).
export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes (replaces cacheTime)
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}
